/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
  responseTime: 0,
};
export const attritionsOverviewByFilterReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    
    case actionType.ATTRITIONS_OVERVIEW_BY_FILTER + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_FILTER + '_RESULT':
      return {
        ...state,
        data: action.result.data?.map((e) => {
          if (Object.prototype.hasOwnProperty.call(e, 'job')) {
            e.name = e.job;
            delete e.job;
          } else if (Object.prototype.hasOwnProperty.call(e, 'organization')) {
            e.name = e.organization;
            delete e.organization;
          }
          return e;
        }),
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_FILTER + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_FILTER + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
